import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import App from './App.vue';
import Router from './Router';
import 'ant-design-vue/dist/reset.css';

createApp(App)
.use(Router)
.use(Antd)
.mount('#app');
